import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import {
  getArrivingVehicleType,
  getArrivalScheduledLabel,
} from '#/transit-tracker/utils/arrivals';
import useEstimatedArrivalText from '#/transit-tracker/hooks/useEstimatedArrivalText';
import useIntlDatetime from '#/shared/hooks/useIntlDatetime';
import * as Styled from './styled';

function ArrivalTimeBadge({ arrival }) {
  const { milliSecondsToTriMetTimeString } = useIntlDatetime();

  const getArrivalScheduledTimeString = a =>
    milliSecondsToTriMetTimeString(a.scheduledTime);

  const { getEstimatedArrivalText } = useEstimatedArrivalText();
  let arrivalTimeBadge = '';

  switch (arrival.status) {
    case 'estimated': {
      const { arrivalText } = getEstimatedArrivalText(arrival);

      if (!arrival.showMilesAway) {
        if (arrival.dropOffOnly) {
          arrivalTimeBadge = (
            <>
              <Styled.DangerLabel>
                <FormattedMessage id="arrivals.track-btn-drop-Off-Only" />
              </Styled.DangerLabel>
              <Styled.CanceledTime>{arrivalText}</Styled.CanceledTime>
            </>
          );
        } else {
          arrivalTimeBadge = (
            <Styled.RealtimeLabel>{arrivalText}</Styled.RealtimeLabel>
          );
        }
      } else {
        arrivalTimeBadge = (
          <>
            <Styled.ScheduledLabel>
              {getArrivalScheduledTimeString(arrival)}{' '}
              {getArrivingVehicleType(arrival)}
            </Styled.ScheduledLabel>
            <Styled.ScheduledLabel>{arrivalText}</Styled.ScheduledLabel>
          </>
        );
      }
      break;
    }
    case 'scheduled': {
      arrivalTimeBadge = (
        <>
          <Styled.ScheduledLabel>
            {getArrivalScheduledLabel(arrival.scheduledTime)}
          </Styled.ScheduledLabel>
          <Styled.ScheduledTime>
            {getArrivalScheduledTimeString(arrival)}
          </Styled.ScheduledTime>
        </>
      );
      break;
    }
    case 'canceled': {
      arrivalTimeBadge = (
        <>
          <Styled.CanceledTime>
            {getArrivalScheduledTimeString(arrival)}{' '}
            {getArrivingVehicleType(arrival)}
          </Styled.CanceledTime>
          <Styled.DangerLabel>
            <FormattedMessage id="arrivals.canceled" />
          </Styled.DangerLabel>
        </>
      );
      break;
    }

    default:
      break;
  }

  return (
    <>
      <ScreenReaderText>
        <FormattedMessage id="arrivals.arrivaltime_acc" />
      </ScreenReaderText>
      {arrivalTimeBadge}
    </>
  );
}

ArrivalTimeBadge.propTypes = {
  /**
   * The arrival to be displayed that contains at least its scheduled or
   * estimated time
   */
  arrival: PropTypes.shape({
    status: PropTypes.string.isRequired,
    scheduledTime: PropTypes.number.isRequired,
    showMilesAway: PropTypes.bool,
    estimatedTime: PropTypes.number,
    feet: PropTypes.number,
    dropOffOnly: PropTypes.bool,
  }).isRequired,
};

export default ArrivalTimeBadge;
